import { useQueryClient } from "@tanstack/react-query";
import { useEffect, type FC } from "react";
import plants from "../../../../assets/images/change-request-confirmation.png";
import { useTypedTranslation } from "../../../hooks";
import * as Styled from "../InflationStepper.styled";
import { InflationStepperProps } from "../InflationStepper.types";

type SuccessProps = InflationStepperProps;

export const Success: FC<SuccessProps> = ({ modal, contractId }) => {
    const { t } = useTypedTranslation();
    const queryClient = useQueryClient();

    useEffect(() => {
        // Invalidate any cached life detail queries for this contract (key starts with 'getLifeDetail')
        queryClient.invalidateQueries({
            predicate: (q) => {
                const key = q.queryKey as unknown as any[];
                return Array.isArray(key) && key[0] === "getLifeDetail" && key[1] === contractId;
            },
        });
        queryClient.invalidateQueries({ queryKey: ["allowedChanges"] });
    }, []);

    return (
        <>
            <Styled.ImageWrapper>
                <Styled.MuiImage src={plants} alt={"success"} />
            </Styled.ImageWrapper>

            <Styled.BodyText>{t("inflationStepper.success.requestReceivedTitle")}</Styled.BodyText>
            <Styled.BodyDescription>
                {t("inflationStepper.success.requestProcessingDescription")}
            </Styled.BodyDescription>

            <Styled.Spacer />

            <Styled.ContinueButtonWrapper>
                <Styled.ContinueButton
                    onClick={() => {
                        modal?.remove();
                    }}
                >
                    {t("global.iUnderstand")}
                </Styled.ContinueButton>
            </Styled.ContinueButtonWrapper>
        </>
    );
};
